import { Controller } from "@hotwired/stimulus"

let sectionEls = null;
let headerEl = null;
let navLinkEls = null;
let popoverEl = null;
let contentEl = null;
let arrowEl = null;
let backgroundEl = null;

let sections = null;

// TODO: generate on the fly
let dimensions = {
  training: { width: 800, height: 0, x: 0, moveX: 250 },
  knowledge: { width: 260, height: 0, x: 0, moveX: 80 },
  company: { width: 320, height: 0, x: 0, moveX: 200 },
  services: { width: 320, height: 0, x: 0, moveX: 0 }
}

let currentHeight = 0;

let popoverLeft = null;

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = [ 'navLink' ]

  connect() {
    // we have to wait else till are elements are loaded
    setTimeout(() => this.caluclateInitialPositions(), 200)
  }

  caluclateInitialPositions() {
    sectionEls = document.querySelectorAll('.nav-section');
    headerEl = document.querySelector('.navbar-header');
    navLinkEls = document.querySelectorAll('.navbar-link');
    popoverEl = document.querySelector('.nav-popover');
    contentEl = document.querySelector('.nav-content');
    arrowEl = document.querySelector('.nav-content-arrow');
    backgroundEl = document.querySelector('.nav-content-bg');

    sections = ['training', 'knowledge', 'company', 'services'];

    popoverLeft = popoverEl.getBoundingClientRect().x;

    this.navLinkTargets.forEach((navLink) => {
      let section =  navLink.getAttribute('data-id');
      let rect = navLink.getBoundingClientRect();
      dimensions[section].arrowX = rect.left + (rect.width / 2) - popoverLeft;

      let sectionContent = document.querySelector(`.nav-section-${section}`);
      
      dimensions[section].height = sectionContent.offsetHeight;
    })

    backgroundEl.style.height = dimensions['training'].height + 'px';

    // Set initial arrow position
    arrowEl.style.transform = `
      translateX(${dimensions.training.arrowX}px)
      rotate(45deg)`;
  }

  hideSection() {
    popoverEl.classList.remove('open');
    backgroundEl.style.display = 'none';
  }

  showSection(event) {
    let section = event.target.getAttribute('data-id');
    let rect = event.target.getBoundingClientRect();
    let navbarContent = document.querySelector('.navbar-content');
    let navbarRect = navbarContent.getBoundingClientRect();

    dimensions[section].x = rect.x - navbarRect.x;
    
    backgroundEl.style.display = 'inherit' 
    popoverEl.classList.add('open');
    
    sectionEls.forEach(el => {
      el.classList.remove('active');
      if (el.getAttribute('data-id') != section) {
        el.style.display = 'none'
      } else {
        el.style.display = 'flex'
        el.style.width = dimensions[section].width + 'px';
      }
    }); 

    let currentHoveredContent = document.querySelector(`.nav-section-${section}`);
    currentHoveredContent.classList.add('active');

    // Position arrow
    arrowEl.style.transform = `
      translateX(${dimensions[section].arrowX}px)
      rotate(45deg)`;

    let sectionContent = document.querySelector(`.nav-section-${section}`);
    dimensions[section].height = sectionContent.offsetHeight;

    backgroundEl.style.height = dimensions['training'].height + 'px';

    // Resize and position background
    backgroundEl.style.transform = `
      translateX(${ dimensions[section].x - dimensions[section].moveX }px)
      scaleX(${ dimensions[section].width / dimensions['training'].width })
      scaleY(${ dimensions[section].height / dimensions['training'].height })
    `;
    
    // Resize and position content
    contentEl.style.width = dimensions[section].width + 'px';
    contentEl.style.height = dimensions[section].height + 'px';
    contentEl.style.transform = `translateX(${ dimensions[section].x - dimensions[section].moveX }px) translateZ(1px)`
  }
}
